module.exports = __webpack_public_path__ + "static/adminlastfree-78697ce7fb90adc487a68424d1040e5d.png";